/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Box } from "@mui/material";
import FieldsetGroup, { FieldsetGroupProps } from "../FieldsetGroup";
import "./DialogContentFieldsetGroup.scss";

export default React.forwardRef(function DialogContentFieldsetGroup(props: FieldsetGroupProps, ref: React.ForwardedRef<unknown>) {
    return (
        <Box className="lan-dialogcontentfieldsetgroup" sx={props.sx} ref={ref}>
            <FieldsetGroup
                {...props}
            />
        </Box>
    );
});
